<template lang="pug">
AppPopover(
  ref="AppPopover"
  :reference="reference"
  lazy
  @hide="close"
)
  template(#body)
    ValidationObserver(ref="dialogObserver")
      .time-span-popover.time_entry_form
        .alert.alert-danger(v-if="baseError") {{ baseError }}
        .row
          .col-sm-12
            AppDurationInput(
              ref="amountField"
              v-model="amount"
              with-seconds="never"
              required
              label="AMOUNT "
            )
        ValidationProvider(
          v-slot="{ errors }"
          mode="lazy"
          rules="required"
          name="reason"
          :model-value="reason"
        )
          .row
            .col-sm-12
              .form-group(:class="{ 'has-error': errors[0] }")
                label.control-label.is-block Reason*
          .row
            .col-xs-12
              .form-group(:class="{ 'has-error': errors[0] }")
                textarea.form-control(
                  v-model="reason"
                  required
                  name="reason"
                  placeholder="Why are you modifying this balance?"
                )
                span.help-block {{ errors[0] }}
        .row
          .col-xs-12
            button.btn.btn-success.btn-block.btn-sm(@click="save") Apply
        .curtain(v-show="saving")
          .spinner-wrapper
            span.hi.hi-spinner.hi-32.text-blue
</template>

<script>
export default {
  name: 'TimeOffBalancesEditPopover',
  props: {
    balance: {
      type: Object,
      required: true,
    },
    reference: {
      type: Element,
      required: true,
    },
  },
  data() {
    return {
      amount: null,
      reason: '',
      errorMessage: 'There was an error when updating this time off balance',
      successMessage: 'Time off balance updated',
      saving: false,
      baseError: null,
    };
  },
  computed: {
    timeOffBalanceParams() {
      return {
        reason: this.reason,
        apply_accruals: false,
        balance_adjustments: [
          {
            time_off_policy_id: this.timeOffPolicyId,
            user_ids: [this.userId],
            amount: this.amount,
            modify_balance: 'replace',
          },
        ],
      };
    },
  },
  mounted() {
    this.open();
  },
  methods: {
    async save(state) {
      this.baseError = null;
      const isValid = await this.$refs.dialogObserver.validate();

      if (isValid) {
        const success = this.success;
        const error = this.error;
        const fin = () => {
          this.saving = false;
        };

        this.saving = true;
        this.$store.dispatch('updateBalances', { params: this.timeOffBalanceParams }).then(success, error).finally(fin);
      }
    },
    success(response) {
      this.$appMessage(this.successMessage);
      this.$store.dispatch('loadData');
      this.$refs.AppPopover.close();
    },
    error(response) {
      if (response.responseJSON) {
        if (response.responseJSON.alert) {
          this.$appMessage(response.responseJSON.alert);
        }
        this.baseError = response.responseJSON.error_message;
        this.$refs.dialogObserver.setErrors(response.responseJSON.errors);
      } else {
        this.$appMessage(this.errorMessage);
      }
    },
    reset() {
      this.userId = this.balance.user_id;
      this.timeOffPolicyId = this.balance.time_off_policy_id;
      this.amount = this.balance.amount;
      this.reason = '';
      this.baseError = null;
    },
    open() {
      this.$refs.AppPopover.open();
      this.reset();

      setTimeout(() => {
        if (this.$refs.amountField) {
          this.$refs.amountField.currentValue = this.amount;
          this.$refs.amountField.$el?.querySelector?.('input')?.focus();
        }
      }, 20);
    },
    close() {
      this.$refs.AppPopover.close();
      this.$emit('close');
    },
  },
};
</script>
